import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import {
  Description as DescriptionIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import WarrantySummary from './WarrantySummary';
import WarrantyFile from './WarrantyFile';

interface WarrantyDetailTabsProps {
  warranty: any;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`warranty-tabpanel-${index}`}
      aria-labelledby={`warranty-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `warranty-tab-${index}`,
    'aria-controls': `warranty-tabpanel-${index}`,
  };
}

const WarrantyDetailTabs: React.FC<WarrantyDetailTabsProps> = ({
  warranty,
}) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="warranty detail tabs"
          sx={{
            '& .MuiTab-root': {
              minHeight: 56,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              py: 1.5,
            },
            '& .MuiTabs-indicator': {
              height: 3,
            },
          }}
        >
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <InfoIcon sx={{ fontSize: '1.2rem' }} />
                <Typography variant="body1">Resumen</Typography>
              </Box>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <DescriptionIcon sx={{ fontSize: '1.2rem' }} />
                <Typography variant="body1">Documento</Typography>
              </Box>
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <WarrantySummary warranty={warranty} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <WarrantyFile warranty={warranty} />
      </TabPanel>
    </Box>
  );
};

export default WarrantyDetailTabs;
